<ngb-alert [hidden]="!show" [type]="'warning'" (closed)="close()">
  Your account has reached the rate limit for your current plan at some point
  during the day.
  <a class="alert-link" href="/account/plan/edit" target="_self">
    Upgrade your plan now</a
  >
</ngb-alert>
